import React, { useEffect } from "react";
import { useParams } from "react-router";
import NewNewProductPage from "./product/NewNewProductPage";

const CONFIG = {
  et: {
    title: "Uuri rohkem",
    description:
      "Õpi päriseluolukordade kaudu, mida toetavad emakeelsete kõnelejate teadmised.",
  },
};

const ProductPage = ({ data }) => {
  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
    document.getElementsByName("description")[0].content =
      CONFIG[lang]?.description;
  }, [lang]);

  return <NewNewProductPage data={data.product_page} />;
};

export default ProductPage;
